import { render, staticRenderFns } from "./AppleAddToHomeScreenModal.vue?vue&type=template&id=46216e9a&scoped=true"
import script from "./AppleAddToHomeScreenModal.vue?vue&type=script&lang=js"
export * from "./AppleAddToHomeScreenModal.vue?vue&type=script&lang=js"
import style0 from "./AppleAddToHomeScreenModal.vue?vue&type=style&index=0&id=46216e9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46216e9a",
  null
  
)

export default component.exports